<template>
  <f7-page class="main-KiloRecord-page">
    <template #fixed>
      <TheNavbar
        nav-title="Registro de Kilos"
        back-btn-enable
      />
    </template>

    <f7-block class="main-KiloRecord no-margin padding-half">
      <!-- Search bar navigation -->
      <div class="content-header-activity-line">
        <div class="content-logo-company padding-right-half">
          <img
            width="auto"
            height="44"
            alt="iconLogo"
            :src="logoClient"
          >
        </div>
        <div class="content-search-entity">
          <UCSearchEntityERP
            :title="$t('searchEntity.line.title.searchProductionLine')"
            :placeholder="$t('searchEntity.line.placeholder.codeLine')"
            :search-text="$t('searchEntity.line.searchText')"
            :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
            :default-etities-list="lineasProduccion"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :next-and-previous-buttons-shown="true"
            :disabled="disabledElementFrm"
            @selection="EventSelectedProductionLine"
          />
          <!-- End Search bar navigation -->
        </div>
        <div class="content-logo-hispatec">
          <div class="text-align-right padding-right margin-left">
            <img
              width="auto"
              height="44"
              alt="iconLogo"
              :src="LOGO_HISPATEC"
            >
          </div>
        </div>
      </div>
      <div>
        <!-- Center -->
        <f7-block :class="{ 'disabled-body': disabledBody }">
          <f7-row>
            <f7-col
              width="66"
              class="box-height"
            >
              <div>
                <div class="card card-outline card-Actividad">
                  <div class="card-header padding-right-half">
                    ACTIVIDAD
                    <div class="actions-container">
                      <UCSortPopover
                        :sort-field-list="sortFieldList"
                        :disabled="disabledElementFrm"
                        class="padding-right-half"
                        @on-change="EventChangeSortField"
                      />
                      <!-- Actualizar formulario -->
                      <f7-link
                        class="animated-spin"
                        @click="GetMainData(false)"
                      >
                        <img
                          alt="iconRefresh"
                          src="@/static/icons/ic_refresh_blue.svg"
                        >
                      </f7-link>
                    </div>
                  </div>
                  <div class="card-content card-content-padding">
                    <f7-block>
                      <f7-row
                        style="margin-bottom: 20px;"
                      >
                        <f7-col class="campo_Filtro_fecha">
                          <UCDatePicker
                            id="date-filter"
                            class="campo_Fecha-input"
                            title="Filtrar por fecha"
                            @onchange="ChangedDateFilter"
                          />
                        </f7-col>
                        <f7-col class="campo_Filtro">
                          Buscar por partida
                          <UCSearch
                            placeholder="Buscar por serie o número de partida"
                            :min-length="0"
                            :find-on-change="true"
                            @change="EventSelectedFilterPartida"
                            @search-bar-value-changed="
                              EventSelectedFilterPartida
                            "
                          />
                        </f7-col>
                        <f7-col class="campo_Filtro">
                          Buscar por articulo
                          <UCSearch
                            placeholder="Buscar por articulo.."
                            :min-length="0"
                            :find-on-change="true"
                            @change="EventSelectedFilterArticulo"
                            @search-bar-value-changed="EventSelectedFilterArticulo"
                          />
                        </f7-col>
                      </f7-row>
                    </f7-block>
                    <UCPreload :show="showPreload" />
                    <div class="content-list-checkbox-scroll">
                      <f7-list
                        v-if="!showPreload"
                        media-list
                        class="list_Orden"
                      >
                        <f7-list-item
                          v-for="(item) of activityList"
                          :key="item.Id"
                          class="Orden"
                          link="#"
                          :title="item.Partida != null ? `${item.Partida.Serie}/${
                            item.Partida.Numero}` : 'Sin Partida'"
                          :subtitle="item.Articulo.Nombre"
                          @click="ConfirmRemoveItem(item)"
                        >
                          <template #after-title>
                            <div
                              v-if="item.FechaFinProduccion === '1900-01-01T00:00:00'"
                              class="btn-stop color-red"
                              @click="PressStopOrderNoDate(item)"
                            >
                              <f7-button
                                fill
                                class="btn"
                              >
                                STOP
                              </f7-button>
                            </div>
                          </template>

                          <span class="span_Fecha-Inicio">
                            {{ FormatDate(item.FechaInicioProduccion) }}
                            <span class="span_Hora-Inicio">
                              {{ FormatTime(item.FechaInicioProduccion) }}
                            </span>
                          </span>
                          <span
                            v-if="item.FechaFinProduccion !== '1900-01-01T00:00:00'"
                            class="span_Fecha-Fin"
                          >
                            {{ FormatDate(item.FechaFinProduccion) }}
                            <span class="span_Hora-Fin">
                              {{ FormatTime(item.FechaFinProduccion) }}
                            </span>
                          </span>
                          <span class="span_Cantidad-Kg">
                            {{ item.Cantidad }} Kg</span>
                        </f7-list-item>
                      </f7-list>
                    </div>
                  </div>
                </div>
              </div>
            </f7-col>
            <!------ PARTE LATERAL DERECHA ---->
            <f7-col
              width="33"
              class="box-height"
            >
              <div class="content-new-activity sticky">
                <div class="card card-outline card-NewProduct">
                  <div class="card-header">
                    Nuevo Producto
                  </div>
                  <div
                    class="
                      card-content card-content-padding
                      no-padding-top
                      margin-top-half
                    "
                  >
                    <UCSearchEntityERP
                      ref="UCPartidaComponent"
                      :title="$t('common.batch')"
                      :placeholder="$t('searchEntity.batch.placeholder.codeBatch')"
                      :search-text="$t('searchEntity.batch.searchText')"
                      :search-cancellation-text="$t('searchEntity.batch.searchCancellationText')"
                      :search-not-found-text="$t('searchEntity.batch.searchNotFoundText')"
                      :end-point-for-code-search="PartidaCodeSearch"
                      :end-point-for-list="PartidasInList"
                      :property-entity-shown-input="['Partida.Serie', 'Partida.Numero']"
                      :property-entity-shown-list-title="['Partida.Serie', 'Partida.Numero']"
                      :property-entity-shown-list-subtitle="['Partida.Articulo.Nombre']"
                      :next-and-previous-buttons-shown="false"
                      :disabled="disabledElementFrm"
                      :separation-character="['/']"
                      @selection="EventSelectedPartidaIn"
                    >
                      <!-- <template #footer="{ item }">
                        <div class="item-inner display-flex flex-direction-row">
                          <div class="item-title-row flex-direction-column">
                            <div class="item-title style_Partida_S_N">
                              {{ item.Partida.Serie + "/" + item.Partida.Numero }}
                            </div>
                            <div class="item-subtitle style_Articulo ">
                              {{ item.Partida.Articulo.Nombre }}
                            </div>
                          </div>
                          <div class="item-text style_Cantidad">
                            {{ item.Cantidad }} Kg.
                          </div>
                        </div>
                      </template> -->
                      <!--   :property-entity-shown-list-title="['Partida.Numero']" -->
                    </UCSearchEntityERP>
                    <UCSearchEntityERP
                      ref="UCArticuloComponent"
                      :title="$t('common.article')"
                      :placeholder="$t('searchEntity.article.placeholder.codeArticle')"
                      :search-text="$t('searchEntity.article.searchText')"
                      :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                      :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                      :end-point-for-code-search="ArticleCodeSearch"
                      :end-point-for-list="ArticlesList"
                      :property-entity-shown-input="['Codigo', 'Nombre']"
                      :property-entity-shown-list-title="['Codigo']"
                      :property-entity-shown-list-subtitle="['Nombre']"
                      :next-and-previous-buttons-shown="false"
                      :disabled="disabledElementFrm"
                      @selection="EventSelectedArticle"
                    />
                  </div>
                  <f7-block-title class="estilo_Cantidad">
                    Cantidad (Kg)
                  </f7-block-title>
                  <f7-list class="campo_Cantidad-input">
                    <f7-list-input
                      type="text"
                      inputmode="numeric"
                      :placeholder="$t('common.quantity')"
                      :value="cantidadIn"
                      @input="cantidadIn = $event.target.value"
                    />
                  </f7-list>
                  <div class="content-new-activity__datetime">
                    <UCDatePicker
                      id="date-start"
                      ref="dateStart"
                      class="campo_Fecha-input"
                      title="Fecha inicio"
                      :disabled="disabledElementFrm"
                      @onchange="ChangedDateInit"
                    />
                    <UCTimePicker
                      id="time-picker-from"
                      ref="timeStart"
                      class="campo_Hora-input"
                      :title="$t('common.hour')"
                      show-seconds
                      template="P2"
                      :disabled="disabledElementFrm"
                      @onchange="ChangeTimeStart"
                    />
                  </div>
                  <div class="content-new-activity__datetime">
                    <UCDatePicker
                      id="date-end"
                      ref="dateEnd"
                      class="campo_Fecha-input"
                      title="Fecha Fin"
                      :default-value="null"
                      :disabled="disabledElementFrm"
                      @onchange="ChangedDateFin"
                    />
                    <UCTimePicker
                      id="time-picker-end"
                      ref="timeEnd"
                      class="campo_Hora-input"
                      :title="$t('common.hour')"
                      show-seconds
                      :date-time-default="null"
                      template="P2"
                      :disabled="disabledElementFrm"
                      @onchange="ChangeTimeEnd"
                    />
                  </div>
                  <f7-block strong>
                    <f7-row tag="p">
                      <f7-col tag="span">
                        <f7-button
                          fill
                          color="orange"
                          class="margin-top-half"
                          :disabled="!validNewElement"
                          @click="CreateNew"
                        >
                          CREAR ORDEN
                        </f7-button>
                      </f7-col>
                    </f7-row>
                  </f7-block>
                </div>
              </div>
            </f7-col>
          </f7-row>
        </f7-block>
      </div>
      <!-- POPUP DETALLE MARCAJES TRABAJADOR -->
      <f7-popup
        class="popup-date-kilos"
        :opened="popupShow"
        @popup:closed="popupShow = false"
      >
        <f7-page>
          <f7-navbar
            sliding
            class="at-navbar secondary-navbar"
            title="Completar registro de kilos"
          >
            <f7-nav-right>
              <f7-link
                popup-close
                icon="icon-close"
                @click="popupShow = false"
              />
            </f7-nav-right>
          </f7-navbar>
          <div>
            <div>
              <div class="estilo_Cantidad block-title">
                Cantidad (Kg)
              </div>
              <f7-list class="estilo_Cantidad__kilos">
                <f7-list-input
                  type="text"
                  inputmode="numeric"
                  :placeholder="$t('common.quantity')"
                  :value="cantidadIndicadaPopup"
                  @input="cantidadIndicadaPopup = $event.target.value"
                />
              </f7-list>
              <div class="content-datetime-popup">
                <UCDatePicker
                  id="date-end-popup"
                  ref="dateEntPopup"
                  class="campo_Fecha-input-popup"
                  title="Fecha Fin"
                  :disabled="disabledElementFrm"
                  @onchange="ChangedDateFinPopup"
                />
                <UCTimePicker
                  id="time-picker-end-popup"
                  ref="timeEntPopup"
                  class="campo_Hora-input-popup"
                  :title="$t('common.hour')"
                  template="P2"
                  :disabled="disabledElementFrm"
                  @onchange="ChangeTimeEndPopup"
                />
              </div>
            </div>
            <div class="container-btns">
              <f7-button
                class="button button-fill color-gray"
                popup-close
                @click="PopupStopCancel"
              >
                {{ $t('common.cancel') }}
              </f7-button>

              <f7-button
                class="button button-fill color-green"
                @click="PopupStopConfirm"
              >
                {{ $t('common.confirm') }}
              </f7-button>
            </div>
            <!-- Datos Trabajador Seleccionado -->
          </div>
        </f7-page>
      </f7-popup>
    </f7-block>
    <!-- Fin Right -->

    <UCConfirmation ref="UCConfirmation" />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';

import { Log } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import APIErp from '@/js/services/APIErp';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import UCSortPopover from '@/components/common/UCSortPopover.vue';
import { LOGO_HISPATEC } from '@/js/common/constants';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import UCSearch from '@/components/common/UCSearch.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import { defineComponent } from 'vue';

/** @import {
 * LineaProduccionArticuloUtilizado,
 * } from '@erpagroapp/types' */

export default defineComponent({
  name: 'FrmKiloRecord',
  components: {
    UCConfirmation,
    UCSearchEntityERP,
    TheNavbar,
    UCTimePicker,
    UCDatePicker,
    UCSortPopover,
    UCSearch,
    UCPreload,
  },

  data() {
    return {
      showPreload: false,
      logoClient: null,
      selectedProductionLine: null,
      dateStart: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      sortFieldList: [],
      sortFieldSelected: null,
      disabledElementFrm: false,
      selectedPartidaIn: null, // PartidaEntrada
      selectedArticle: null,
      cantidadIn: 0,
      activityList: [],
      activityListOrigin: [],
      selectedItem: null,
      dateFilter: null,
      abrirDialogo: true, // Variable que se usa para controlar que no se ejecute el codigo del click ConfirmRemoveItem al pulsar el btn stop
      popupShow: false, // mostrar popup al pulsar el btn stop
      cantidadIndicadaPopup: 0, // cantidad kg popup
      dateEndPop: null, // valores fecha y hora del popup
      timeEndPop: null,
      itemSelected: null, // elemento seleccionado de la malla
      lineasProduccion: null,
      LOGO_HISPATEC,
      logoApp: useSettingRef('App.Logo'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['getLineasProduccion']),

    validNewElement() {
      if (
      /* this.cantidadIn > 0
        && */ this.selectedArticle !== null
        // && this.selectedPartida !== null
        && this.dateStart !== null
        /* && this.dateEnd !== null */
        && this.timeStart !== null
        /* && this.timeEnd !== null */
      ) {
        return true;
      }
      return false;
    },
    disabledBody() {
      if (this.selectedProductionLine === null) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    async StartForm() {
      Log(this, this.StartForm.name);
      this.logoClient = this.GetLogo();
      this.dateStart = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD',
      );
      this.dateEndPop = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD',
      );
      this.dateStart = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD',
      );
      // this.dateEnd = HiDateTimeSupport.FormatDateTime(Date.now(), 'YYYY-MM-DD');
      this.timeStart = HiDateTimeSupport.FormatDateTime(Date.now(), 'HH:mm');
      this.timeEntPopup = HiDateTimeSupport.FormatDateTime(Date.now(), 'HH:mm');
      // this.timeEnd = HiDateTimeSupport.FormatDateTime(Date.now(), 'HH:mm');
      this.sortFieldList = [
        {
          Name: 'Fecha Inicio',
          AssociatedFilterProperty: 'FechaInicioProduccion',
        },

        {
          Name: 'Fecha Fin',
          AssociatedFilterProperty: 'FechaFinProduccion',
        },
        {
          Name: 'Articulos',
          AssociatedFilterProperty: 'Articulo.Nombre',
        },
        {
          Name: 'Partidas',
          AssociatedFilterProperty: 'Partida.Numero',
        },
      ];
      [this.sortFieldSelected] = this.sortFieldList;
      if (this.selectedProductionLine != null) {
        this.GetMainData();
      }
      this.lineasProduccion = this.getLineasProduccion;
      // this.puntosDePaletizado = this.lineasProduccion.PuntosDePaletizado;
    },
    async GetMainData() {
      // HiDialog.Preloader(true, 'Cargando registros');
      this.showPreload = true;
      this.activityList = await this.GetProductionLineArticleUsed(
        this.selectedProductionLine,
        this.dateFilter,
      );
      this.activityListOrigin = this.activityList; // Para filtros sobre los resultados
      // HiDialog.Preloader(false);
      const objetoOrden = {
        AssociatedFilterProperty: 'FechaInicioProduccion',
        Name: 'Fecha Inicio',
      };
      this.SortListElement(objetoOrden);
      this.showPreload = false;
    },

    async CreateNew() {
      Log(this, this.CreateNew.name);

      if (this.selectedProductionLine == null) {
        HiNotification.Toast(this.$t('common.needToSelectAProductionLine'), 6000);
        return;
      }
      /*
      if (this.selectedPartidaIn == null) {
        HiNotification.Toast('Es necesario seleccionar una partida.', 6000);
        return;
      }
      */
      if (this.selectedArticle == null) {
        HiNotification.Toast(this.$t('common.needToSelectAnArticle'), 6000);
        return;
      }
      HiDialog.Preloader(true, 'Guardando registro de kilos');

      const formattedEndDate = this.dateEnd && this.timeEnd ? `${this.dateEnd} ${this.timeEnd}` : null;

      /** @type {PartialDeep<LineaProduccionArticuloUtilizado>} */
      const newProductionLineArticleUsed = {
        LineaProduccion: this.selectedProductionLine,
        Partida: this.selectedPartidaIn?.Partida ?? null,
        Articulo: this.selectedArticle,
        Cantidad: this.cantidadIn,
        FechaInicioProduccion: `${this.dateStart} ${this.timeStart}`,
        FechaFinProduccion: formattedEndDate,
      };
      const resultAdd = await this.CreateNewProductionLineArticleUsed(newProductionLineArticleUsed);
      HiDialog.Preloader(false);
      if (!resultAdd) {
        HiNotification.Alert('No ha sido posible almacenar el registro de kilos', 'El registro no pudo ser guardado');
      }
      this.GetMainData();
      this.$refs.dateEnd.resetToCurrentDate();
      this.$refs.timeEnd.ResetToCurrentTime();
      this.$refs.dateEnd.resetToNullValue();
      this.$refs.timeEnd.ResetToNullValue();
      this.cantidadIn = 0;
    },
    async UpdateRegistroSinFechaFin() {
      Log(this, this.CreateNew.name);
      if (this.selectedProductionLine == null) {
        HiNotification.Toast(this.$t('common.needToSelectAProductionLine'), 6000);
        return;
      }

      HiDialog.Preloader(true, 'Guardando registro de kilos');
      const fechaIncio = HiDateTimeSupport.FormatDateTime(
        this.itemSelected.FechaInicioProduccion,
        'YYYY-MM-DD',
      );

      /** @type {PartialDeep<LineaProduccionArticuloUtilizado>} */
      const newProductionLineArticleUsed = {
        Id: 0,
        LineaProduccion: this.selectedProductionLine,
        Partida: this.itemSelected?.Partida ?? null,
        Articulo: this.itemSelected?.Articulo ?? null,
        Cantidad: this.cantidadIndicadaPopup,
        FechaInicioProduccion: `${fechaIncio} ${this.FormatTime(this.itemSelected.FechaInicioProduccion)}`,
        FechaFinProduccion: `${this.dateEndPop} ${this.timeEndPop}`,
      };

      await this.RemoveItemUpdated();
      const resultAdd = await this.CreateNewProductionLineArticleUsed(newProductionLineArticleUsed);
      this.popupShow = false;
      HiDialog.Preloader(false);
      if (!resultAdd) {
        HiNotification.Alert('No ha sido posible almacenar el registro de kilos', 'El registro no pudo ser guardado');
      }

      this.GetMainData();
      this.cantidadIn = 0;
    },
    async CreateNewProductionLineArticleUsed(newObj) {
      Log(this, this.CreateNewProductionLineArticleUsed.name);
      try {
        await APIErp.callCreateNewProductionLineArticleUsed([newObj]);
        return true;
      } catch {
        return false;
      }
    },
    GetLogo() {
      return this.logoApp || LOGO_HISPATEC;
    },
    async EventSelectedProductionLine(objProductionLine) {
      Log(this, this.EventSelectedProductionLine.name);
      this.selectedProductionLine = objProductionLine;
      if (objProductionLine != null) {
        this.GetMainData();
      } else {
        this.Clear();
      }
    },
    PressStopOrderNoDate(item) {
      /* CERRAR UNA ORDERN QUE NO TENIA KILOS O QUE NO TENIA FECHA DE FINAL */
      this.$refs.dateEntPopup.resetToCurrentDate();
      this.$refs.timeEntPopup.ResetToCurrentTime();
      this.cantidadIndicadaPopup = item.Cantidad;
      this.itemSelected = item;
      this.abrirDialogo = false;
      this.popupShow = true;
    },
    PopupStopCancel() {
      Log(this, this.PopupStopCancel.name);
      this.$refs.dateEntPopup.resetToCurrentDate();

      this.$refs.timeEntPopup.ResetToCurrentTime();
      // this.$refs.componentHiUpdateApp.CheckNewVersionAvailable(true);
    },
    PopupStopConfirm() {
      Log(this, this.PopupStopConfirm.name);
      this.UpdateRegistroSinFechaFin();
      this.$refs.UCArticuloComponent.Clear();
      this.cantidadIn = 0;
      this.$refs.dateEnd.resetToCurrentDate();
      this.$refs.timeEnd.ResetToCurrentTime();
      this.$refs.dateEnd.resetToNullValue();
      this.$refs.timeEnd.ResetToNullValue();
    },
    Clear() {
      Log(this, this.Clear.name);
      this.sortFieldList = null;
      this.sortFieldSelected = null;
      this.activityList = [];
      this.activityListOrigin = [];
      this.selectedItem = null;
    },
    EventSelectedPartidaIn(objPartida) {
      Log(this, this.EventSelectedPartidaIn.name);
      if (this.selectedPartidaIn === null && objPartida != null) {
        this.selectedPartidaIn = objPartida;
        this.$refs.UCArticuloComponent.SelectEntity(this.selectedPartidaIn.Partida.Articulo, true);
        // TODO --> Proponer los kilos en cantidad.
        this.cantidadIn = this.selectedPartidaIn.Cantidad;
        this.$refs.dateStart.resetToCurrentDate();
        this.$refs.timeStart.ResetToCurrentTime();
      } else if (this.selectedPartidaIn != null && objPartida === null) {
        this.selectedPartidaIn = objPartida;
        this.$refs.UCArticuloComponent.Clear();
        this.cantidadIn = 0;
        this.$refs.dateEnd.resetToCurrentDate();
        this.$refs.timeEnd.ResetToCurrentTime();
        this.$refs.dateEnd.resetToNullValue();
        this.$refs.timeEnd.ResetToNullValue();
      }
    },
    EventSelectedArticle(objArticulo) {
      Log(this, this.EventSelectedArticle.name);
      if (this.selectedArticle === null && objArticulo != null) {
        this.selectedArticle = objArticulo;
        this.$refs.dateStart.resetToCurrentDate();
        this.$refs.timeStart.ResetToCurrentTime();
      } else if (this.selectedArticle != null && objArticulo === null) {
        this.selectedArticle = objArticulo;
        this.$refs.UCPartidaComponent.Clear();
        this.cantidadIn = 0;
        this.$refs.dateEnd.resetToCurrentDate();
        this.$refs.timeEnd.ResetToCurrentTime();
        this.$refs.dateEnd.resetToNullValue();
        this.$refs.timeEnd.ResetToNullValue();
      }
    },
    ChangedDateInit(newDateValue) {
      Log(this, this.ChangedDateInit.name);
      this.dateStart = HiDateTimeSupport.FormatDateTime(
        newDateValue,
        'YYYY-MM-DD',
      );
    },
    ChangedDateFin(newDateValue) {
      Log(this, this.ChangedDateFin.name);
      this.dateEnd = HiDateTimeSupport.FormatDateTime(
        newDateValue,
        'YYYY-MM-DD',
      );
    },
    ChangedDateFinPopup(newDateValue) {
      Log(this, this.ChangedDateFinPopup.name);
      this.dateEndPop = HiDateTimeSupport.FormatDateTime(
        newDateValue,
        'YYYY-MM-DD',
      );
    },
    ChangeTimeStart(newTimeValue) {
      Log(this, this.ChangeTimeStart.name);
      this.timeStart = newTimeValue;
    },
    ChangeTimeEnd(newTimeValue) {
      Log(this, this.ChangeTimeEnd.name);
      this.timeEnd = newTimeValue;
    },
    ChangeTimeEndPopup(newTimeValue) {
      Log(this, this.ChangeTimeEndPopup.name);
      this.timeEndPop = newTimeValue;
    },
    // -----Ordenar la lista-----
    SortListElement(val) {
      Log(this, this.SortListElement.name);
      switch (val.AssociatedFilterProperty) {
        case 'FechaInicioProduccion':
          this.activityList = this.activityList.sort((a, b) => {
            if (
              a[val.AssociatedFilterProperty] > b[val.AssociatedFilterProperty]
            ) {
              return -1;
            }
            if (
              a[val.AssociatedFilterProperty] < b[val.AssociatedFilterProperty]
            ) {
              return 1;
            }
            return 0;
          });
          break;
        case 'FechaFinProduccion':
          this.activityList = this.activityList.sort((a, b) => {
            if (
              a[val.AssociatedFilterProperty] > b[val.AssociatedFilterProperty]
            ) {
              return -1;
            }
            if (
              a[val.AssociatedFilterProperty] < b[val.AssociatedFilterProperty]
            ) {
              return 1;
            }
            return 0;
          });
          break;
        case 'Partida.Numero':
          this.activityList = this.activityList.sort((a, b) => {
            if (a.Partida.Numero < b.Partida.Numero) {
              return -1;
            }
            if (a.Partida.Numero > b.Partida.Numero) {
              return 1;
            }
            return 0;
          });
          break;
        case 'Articulo.Nombre':
          this.activityList = this.activityList.sort((a, b) => {
            if (a.Articulo.Nombre < b.Articulo.Nombre) {
              return -1;
            }
            if (a.Articulo.Nombre > b.Articulo.Nombre) {
              return 1;
            }
            return 0;
          });
          break;
        default:
          this.selectedArticle = this.selectedArticle.sort(
            (a, b) => a.Id - b.Id,
          );
          break;
      }
    },
    // ********************************Filtrar por partida********************************
    EventSelectedFilterPartida(val) {
      Log(this, this.EventSelectedFilterPartida.name);
      this.activityList = this.activityListOrigin;
      // this.SortListElementNuevo(val);
      this.FilterListPartida(val);
      this.sortFieldSelected = val;
    },
    FilterListPartida(filter) {
      Log(this, this.FilterListPartida.name);
      if (filter === '') {
        this.activityList = this.activityListOrigin;
      } else {
        this.activityList = this.activityList.filter((e) => e.Partida != null
          && e.Partida.Numero.toString().toLowerCase().includes(filter.toLowerCase()));
      }
    },
    // ********************************Filtrar por articulo********************************

    EventSelectedFilterArticulo(val) {
      Log(this, this.EventSelectedFilterArticulo.name);
      // this.SortListElementNuevo(val);
      this.activityList = this.activityListOrigin;
      this.FilterListArticulo(val);
      this.sortFieldSelected = val;
    },
    FilterListArticulo(filter) {
      Log(this, this.FilterListArticulo.name);
      if (filter === '') {
        this.activityList = this.activityListOrigin;
      } else {
        this.activityList = this.activityList.filter((e) => e.Articulo.Nombre.toLowerCase().includes(filter.toLowerCase()));
      }
    },
    // ********************************iltrar por fecha********************************
    EventChangeSortField(val) {
      Log(this, this.EventChangeSortField.name);
      this.SortListElement(val);
      this.sortFieldSelected = val;
    },
    async ChangedDateFilter(newDateValue) {
      Log(this, this.ChangedDateFilter.name);
      this.dateFilter = newDateValue;
      if (this.selectedProductionLine != null) {
        this.GetMainData();
      }
    },
    ActivityCodeSearch(params) {
      Log(this, this.ActivityCodeSearch.name);
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      Log(this, this.ActivityList.name);
      return APIErp.callProductionActivityListXLineAuthorized(
        this.selectedProductionLine.Id,
      );
    },
    async GetProductionLineArticleUsed(objProductionLine, dateTime) {
      Log(this, this.GetProductionLineArticleUsed.name);
      let data = [];
      try {
        const res = await APIErp.callProductionLineArticleUsed(
          objProductionLine.Id,
          dateTime,
        );
        data = res.data;
      } catch {
        HiNotification.Toast('Ocurrió un problema al consultar los datos...');
      }
      return data;
    },
    PartidaCodeSearch(params) {
      Log(this, this.PartidaCodeSearch.name);
      return APIErp.callPartidaCodeSearch(params);
    },
    PartidasInList() {
      Log(this, this.PartidasInList.name);
      return APIErp.callPartidasInList();
    },
    ArticleCodeSearch(params) {
      Log(this, this.ArticleCodeSearch.name);
      return APIErp.callArticlesRawMaterialList(params); // Articulos materia prima con filtro
    },
    ArticlesList() {
      Log(this, this.ArticlesList.name);
      return APIErp.callArticlesRawMaterialList(''); // Articulos materia prima Todos
    },
    // ********************************Borrar elemnto de activityList************************
    ConfirmRemoveItem(obj) {
      Log(this, this.ConfirmRemoveItem.name);
      if (this.abrirDialogo) {
        this.selectedItem = obj;
        this.$refs.UCConfirmation.create(
          'Eliminar Item',
          'El elemento seleccionado del será eliminado de forma permanente. ¿Estás seguro que quieres eliminar el marcaje?',
          this.RemoveItem,
        );
        this.$refs.UCConfirmation.show();
      } else {
        this.abrirDialogo = true;
      }
    },
    async RemoveItem() {
      Log(this, this.RemoveItem.name);
      if (this.selectedItem === null) {
        HiNotification.Toast(this.$t('common.needToSelectAnElement'));
        return;
      }
      HiDialog.Preloader(true, 'Eliminando Item');
      await APIErp.callRemoveProductionLineArticleUsed([this.selectedItem]);
      HiDialog.Preloader(false);
      this.GetMainData();
    },
    async RemoveItemUpdated() {
      Log(this, this.RemoveItem.name);
      await APIErp.callRemoveProductionLineArticleUsed([this.itemSelected]);
      HiDialog.Preloader(false);
    },
    FormatTime(value) {
      return HiDateTimeSupport.FormatDateTime(
        value,
        'HH:mm',
      );
    },
    FormatDate(value) {
      return HiDateTimeSupport.FormatDateTime(
        value,
        'DD/MM/YYYY',
      );
    },
  },
});
</script>

<style scoped lang="scss">
.content-grid {
  display: grid;
  row-gap: 2vh;
  grid-template-columns: 0.8fr 2fr 1.2fr;
  column-gap: 1vw;
}

.content-grid > div:nth-child(1) {
  grid-column: span 1;
}

.content-grid > div:nth-child(2) {
  grid-column: span 1;
  grid-row: 2 span;
}

.main-KiloRecord {
  // TODO: Remove when migrated to new styles
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --f7-list-item-min-height: 44px;
  --f7-list-item-padding-vertical: 0;
  --f7-card-header-font-weight: 400;
  --f7-card-header-min-height: 30px;
  --f7-list-item-padding-horizontal: 16px;
  --search-title-color: var(--f7-block-title-text-color);
  --date-picker-label-color: var(--f7-block-title-text-color);

  .card {
    border: 1px solid var(--f7-card-outline-border-color);
  }

  .card-header {
    font-size: var(--f7-card-header-font-size);
    font-weight: var(--f7-card-header-font-weight);
    min-height: var(--f7-card-header-min-height);
    padding: var(--f7-card-header-padding-vertical) var(--f7-card-header-padding-horizontal);
    letter-spacing: 0;
  }

  .card-content-padding {
    padding: 6px 8px;
  }
  //
}

.main-KiloRecord,
.panel {
  height: 100%;
  overflow: hidden;

  .content-header-activity-line {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    padding: 8px 0 10px;
    margin-bottom: 6px;

    .block-title {
      display: none;
    }

    .content-searcher-erp {
      &__input {
        margin: 0 5px;
      }
    }
  }

  .badge {
    height: 22px;
    width: 22px;
    font-size: 15px;
    background: #e4e4e4;
    color: var(--his-metal);
    font-weight: 500;
  }

  .card {
    margin: 0;

    .card-NewProduct {
      height: 50vh;
    }

    .card-header {
      background-color: #ebecf0;
      text-transform: uppercase;
      color: var(--his-slate-blue);
    }
  }

  .content-list-checkbox-item,
  .content-title-select {
    padding: 7px 15px;
    background: #f4f5f7;
    margin-bottom: 2px;
    border: 1px solid #ebebed;
    border-radius: 3px;

    &.incidence {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #ff5630;
    }

    &.out-of-line {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #fcff30;
    }
  }

  .content-list-checkbox-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > div {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    label {
      margin-right: 10px;
    }

    &__details {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;

      &--title {
        color: var(--his-dark-blue);
      }

      &--subtitle {
        color: var(--his-kiwi-pulp);
        text-transform: uppercase;
      }

      img {
        border-radius: 50%;
        margin: 0 10px 0 0;
        width: 64px;
        height: 64px;
      }

      &--total {
        display: flex;

        img {
          height: 20px;
          width: 20px;
          margin: 0;
          padding: 0 0 0 5px !important;
          border-radius: 0;
        }
      }
    }

    &__time {
      color: var(--his-slate-blue);
      font-size: 28px;
      display: flex;
      align-items: center;

      &::after {
        font-family: "framework7-core-icons";
        font-weight: normal;
        direction: ltr;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        -moz-font-feature-settings: "liga";
        font-feature-settings: "liga";
        text-align: center;
        display: block;
        margin-left: 15px;
        font-size: var(--f7-list-chevron-icon-font-size);
        color: var(--f7-list-chevron-icon-color);
        pointer-events: none;
        right:
          calc(
            var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-right)
          );
        content: var(--f7-list-chevron-icon-right);
      }
    }

    &.checked {
      background-color: var(--his-steel-blue);
      color: #fff;

      .badge {
        background-color: #253858;
        color: #fff;
      }
    }
  }

  .content-title-select {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__input {
      display: flex;
      align-items: center;
      color: var(--his-steel-blue);
      font-weight: 500;
      font-size: 15px;
      text-transform: uppercase;

      label {
        margin-right: 12px;
      }
    }
  }

  .content-new-activity {
    &__datetime {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        width: 100%;
      }

      > div:first-child {
        margin-right: 15px;
      }

      > div:nth-child(2) {
        max-width: 120px !important;
      }

      input {
        color: var(--his-dark-blue);
        font-weight: 500;
        font-size: 16px;
      }
    }
  }

  label.item-checkbox input[type="checkbox"]:checked ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:checked ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:checked ~ i,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:indeterminate ~ i {
    background-color: #566784;
    border-color: #566784;
    zoom: 1.3;
  }

  .icon-checkbox {
    zoom: 1.3;
  }

  .actions-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

a.panel-close {
  background: var(--his-dark-blue);
  display: flex;
}

.ios .icon-checkbox,
.ios .checkbox i {
  zoom: 1.1 !important;
}

@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr 2fr;
  }

  .content-logo-hispatec {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr 3fr !important;
  }
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 530px) {
  .content-logo-company {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr !important;
  }

  .content-list-checkbox-item__details {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .content-list-checkbox-item__time {
    font-size: 18px !important;
    font-weight: 600;
    padding-left: 10px;
  }

  .content-list-checkbox-item__details img.avatar-round {
    width: 48px !important;
    height: 48px !important;
  }
}

.box-height {
  height: 100vh;
}

.span-text-error {
  color: red;
  font-size: 11px;
  opacity: 0.7;
}

.content-list-checkbox-scroll {
  height: calc((100vh - var(--information-bar-height)) * 0.63);
  overflow-y: auto;
}

.campo_Filtro {
  line-height: 2;
  color: var(--his-slate-blue);
  margin-top: 10px;
  margin-bottom: 10px;
}

.campo_Filtro_fecha {
  line-height: 2;
  --date-picker-label-color: var(--his-slate-blue);

  margin-top: 12px;
  margin-bottom: 10px;
}

.input_Filtro-fecha {
  bottom: 74.62%;
  background: var(--his-tierra-white);
  border: 0.8px solid var(--his-silver);
  border-radius: 6.4px;
  height: 44px;
  padding: 0 8px;
}

.campo_Filtro-fecha {
  line-height: 2;
  text-align: center;
  color: var(--his-dark-blue);
  margin-bottom: 10px;
}

.popup-date-kilos {
  .container-btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 25px;
    height: 30vh;
    align-items: flex-end;

    .button {
      width: 150px;
    }
  }
}

.list_Orden {
  background: #fff;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 5px;
  margin-top: 10px;
}

.Orden {
  height: 10vh;
  margin-bottom: 10px;
  background: var(--his-bg);
  border: 1px solid rgb(212 212 212 / 29.9%);
  box-sizing: border-box;
  border-radius: 6px;

  .item-content {
    .item-inner {
      .item-title-row {
        .btn-stop {
          margin-right: 50px;

          .btn {
            height: 20px;
          }
        }
      }
    }
  }
}

.span_Fecha-Inicio {
  width: 164px;
  height: 22px;
  left: 142px;
  top: 291px;
  background: #ebecf0;
  border-radius: 12px;
  padding-left: 10px;
  margin-right: 10px;
}

.span_Hora-Inicio {
  width: 60px;
  height: 22px;
  left: 246px;
  top: 291px;
  background: var(--his-kiwi-pulp);
  border-radius: 12px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 20px;
}

.span_Fecha-Fin {
  width: 175px;
  height: 22px;
  left: 327px;
  top: 291px;
  background: #ebecf0;
  border-radius: 12px;
  padding-left: 10px;
  margin-left: 10px;
}

.span_Hora-Fin {
  width: 71px;
  height: 22px;
  left: 431px;
  top: 291px;
  background: var(--his-mandarina);
  border-radius: 12px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 20px;
}

.span_Cantidad-Kg {
  float: right;
  top: 236px;
  font-weight: 500;
  font-size: 30px;
  line-height: 4vh;
  color: var(--his-slate-blue);
}

.estilo_Cantidad {
  height: 14.06px;
  line-height: 14px;
  padding-left: 7px;
  padding-bottom: 2px;
  box-sizing: border-box;

  &__kilos {
    padding-left: 10px;
    padding-right: 10px;
    background: #fff;
    border: 1px solid var(--his-silver);
    border-radius: 6.25px;
    margin-left: 10px !important;
    margin-right: 10px !important;
    margin-top: 6px;
  }
}

.content-datetime-popup {
  --date-picker-label-color: var(--f7-block-title-text-color);
  padding-left: 10px;
  padding-right: 10px;
}

.campo_Cantidad-input {
  border: 0.78125px solid var(--his-silver);
  border-radius: 6.25px;
  margin-left: 10px !important;
  margin-right: 10px !important;
  margin-top: 6px;
}

.campo_Fecha-input {
  margin-right: 5px !important;
  margin-left: 10px !important;
  padding: 0 !important;
}

.campo_Hora-input {
  margin-right: 10px !important;
  margin-left: 5px !important;
  padding: 0 !important;
}

.disabled-body {
  opacity: 0.6;
  pointer-events: none;
}

.style_Partida_S_N {
  font-weight: 450;
  font-size: 25px;
  line-height: 27px;
  color: var(--his-dark-blue);
}

.style_Articulo {
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  color: var(--his-dark-blue);
}

.style_Cantidad {
  font-weight: 500;
  font-size: 28px;
  line-height: 35px;
  color: var(--his-slate-blue);
}
</style>
